import context from '@/providers/context'
import * as routing from '@/providers/routing'
import * as cookies from '@/helpers/cookies'

// lazy component loading
const Apptoken = () => import(/* webpackChunkName: "apptokens" */ './Apptoken.vue');
const ApptokenWizard = () => import(/* webpackChunkName: "apptokens" */ './CreateApptoken.vue');
const ApptokenSelect = () => import(/* webpackChunkName: "apptokens" */ './ApptokenSelect.vue');
const AppsList = () => import(/* webpackChunkName: "apptokens" */ './apps/List.vue');
const App = () => import(/* webpackChunkName: "apptokens" */ './apps/App.vue');
const AppSettings = () => import(/* webpackChunkName: "apptokens" */ './apps/Settings.vue');
const AppTokens = () => import(/* webpackChunkName: "apptokens" */ './apps/Tokens.vue');
const AppPermissions = () => import(/* webpackChunkName: "apptokens" */ './apps/Permissions.vue');

//ROUTES
export const routes = [
  {
    path: '/apptokens/new',
    name: 'apptokens.new',
    component: ApptokenWizard,
    meta: {
      priority: 50,
    }
  },
  {
    path: '/apptokens/edit',
    name: 'apptokens.edit',
    component: Apptoken,
    meta: {
      menu: false,
      trans: 'titles.apptokens',
    }
  },
  {
    path: '/apptokens/select',
    name: 'apptokens.select',
    component: ApptokenSelect,
    meta: {
      priority: 50,
    }
  },
  {
    path: '/apptokens/apps',
    name: 'apptokens.apps',
    component: AppsList,
    meta: {
      trans: 'titles.apptokensapps',
      icon: 'development',
    },
  },
  {
    path: '/apptokens/apps/:id',
    name: 'apptokens.apps.show',
    redirect: {name: 'apptokens.apps.show.settings'},
    props: true,
    component: App,
    meta: {
      root: true,
      up: 'apptokens.apps',
    },
    children: [
      {
        path: 'settings',
        name: 'apptokens.apps.show.settings',
        component: AppSettings,
        meta: {
          trans: 'apptokens:apps.settings',
          icon: 'cog',
        },
      },
      {
        path: 'tokens',
        name: 'apptokens.apps.show.tokens',
        component: AppTokens,
        meta: {
          trans: 'apptokens:apps.tokens',
          icon: 'key',
        },
      },
      {
        path: 'permissions',
        name: 'apptokens.apps.show.permissions',
        component: AppPermissions,
        meta: {
          trans: 'apptokens:apps.permissions.title',
          icon: 'stack',
        },
      },
    ],
  },
];

//ROUTER GUARD
export function guard(router) {

  //watch: if there is no apptoken, redirect to wizard
  // context.watch((state) => ([state.apptoken, state.user]), function ([apptoken, user]) {
  //   if (user !== undefined && apptoken !== undefined && !apptoken.length && !context.getters.admin) {
  //     console.log('Guard: No apptoken.');
  //     router.push({name: 'apptokens.new'});
  //   }
  // });

  router.beforeResolve((to, from, next) => {
    context.getters.async(['user', 'apptoken']).then(([user, apptoken]) => {
      //everything OK -> go to dashboard
      // if (to.name === 'apptokens.new' && (apptoken.length || context.getters.admin)) {
      //   console.log('Guard: User already has an apptoken or is admin.');
      //   return next({name: 'dashboard'});
      // }
      // //is admin, apptoken is not chosen -> force choosing the apptoken
      // var selectCookie = () => routing.priorityNext(to, {name: 'apptokens.select'}, next, router);
      // if ((!apptoken || !apptoken.length) && context.getters.admin && to.name !== 'apptokens.select') {
      //   var chosen_id = cookies.getCookie(cookies.names.admin);
      //   if (chosen_id && Number(chosen_id)) {
      //     return context.getters.api.get('apptokens/' + chosen_id)
      //       .then(token => context.commit('choose_apptoken', token))
      //       .then(() => next())
      //       .catch(r => {
      //         console.log('Guard: Cannot get token from cookie ' + chosen_id);
      //         cookies.eraseCookie(cookies.names.admin);
      //         return selectCookie();
      //       })
      //     ;
      //   } else {
      //     console.log('Guard: Admin has to select the apptoken.');
      //     return selectCookie();
      //   }
      // }
      // //not admin -> cannot see "select apptoken" view
      // if (!context.getters.admin && to.name === 'apptokens.select') {
      //   console.log('Guard: User is not admin and cannot select an apptoken.');
      //   return next({name: 'dashboard'});
      // }
      // //not ok
      // if (!apptoken.length && to.name !== 'apptokens.new' && !context.getters.admin) {
      //   console.log('Guard: Company has no apptoken and must create one.');
      //   return routing.priorityNext(to, {name: 'apptokens.new'}, next, router);
      // }
      return next();
    }).catch(e => {
      console.log('Apptoken router guard failed', e);
      return next();
    });
  });
}

// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'apptokens', bundle);
}


// WEBPACK FOOTER //
// ./src/sections/apptokens/index.js